// src/pages/quality/QualitySettingsPage.jsx
import { useState, useEffect } from 'react';
import api from '../../services/api';
import useAuth from '../../hooks/useAuth';

// Компоненты
import CreateCriteriaModal from '../../components/quality/CreateCriteriaModal';
import CriteriaItem from '../../components/quality/CriteriaItem';

const QualitySettingsPage = () => {
  const { projects: userProjects } = useAuth();
  const [selectedProjectId, setSelectedProjectId] = useState('');
  const [criteria, setCriteria] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Загрузка критериев
  useEffect(() => {
    if (selectedProjectId) {
      api.get(`/quality/criteria?project_id=${selectedProjectId}`)
        .then((res) => {
          const sorted = res.data.data.sort((a, b) => a.position - b.position);
          setCriteria(sorted);
        })
        .catch((err) => {
          console.error('Ошибка загрузки критериев:', err);
          // showToast уже вызван через interceptor
        });
    } else {
      setCriteria([]);
    }
  }, [selectedProjectId]);

  const handleProjectChange = (e) => {
    const value = e.target.value;
    setSelectedProjectId(value ? Number(value) : '');
  };

  // --- Создание нового критерия ---
  const handleCreate = (newCriteriaData) => {
    api.post('/quality/criteria', newCriteriaData)
      .then((res) => {
        const newCriterion = res.data; // ← res.data содержит критерий + message
        setCriteria((prev) => [...prev, newCriterion].sort((a, b) => a.position - b.position));
      })
      .catch((err) => {
        console.error('Ошибка создания критерия:', err);
        // showToast уже вызван через interceptor
      });
  };

  // --- Обновление вариантов критерия ---
  const handleUpdateOptions = (criteriaId, updatedOptions) => {
    setCriteria((prev) =>
      prev.map((c) => (c.id === criteriaId ? { ...c, options: updatedOptions } : c))
    );
  };

  // --- Перемещение критерия ---
  const moveCriterion = (index, direction) => {
    const newPos = direction === 'up' ? index - 1 : index + 1;
    if (newPos < 0 || newPos >= criteria.length) return;

    const newCriteria = [...criteria];
    const temp = newCriteria[index];
    newCriteria[index] = newCriteria[newPos];
    newCriteria[newPos] = temp;

    // Обновляем локальный порядок
    newCriteria.forEach((c, i) => {
      c.position = i;
    });
    setCriteria(newCriteria);

    // Обновляем позицию на сервере
    const criterionToMove = newCriteria[newPos];
    api.patch(`/quality/criteria/${criterionToMove.id}/position`, { position: newPos })
      .catch((err) => {
        console.error('Ошибка обновления позиции:', err);
        // При ошибке — откат
        setCriteria(criteria);
      });
  };

  return (
    <div className="quality-settings-page">
      <h2>Настройка критериев качества</h2>

      {/* Выбор проекта */}
      <div className="project-selector">
        <label>Выберите проект: </label>
        <select value={selectedProjectId} onChange={handleProjectChange}>
          <option value="">-- Выберите проект --</option>
          {userProjects.map((project) => (
            <option key={project.id} value={project.id}>
              {project.name_text}
            </option>
          ))}
        </select>
      </div>
      {/*{projects.length === 0 ? (*/}
      {/*  <div className="no-projects">*/}
      {/*    У вас нет доступных проектов.*/}
      {/*  </div>*/}
      {/*) : (*/}
      {/*  <div className="form-group">*/}
      {/*    <label htmlFor="projectSelect">Выберите проект:</label>*/}
      {/*    <select*/}
      {/*      id="projectSelect"*/}
      {/*      value={selectedProjectId || ''}*/}
      {/*      onChange={handleProjectChange}*/}
      {/*      className="project-select"*/}
      {/*    >*/}
      {/*      <option value="">-- Выберите проект --</option>*/}
      {/*      {userProjects.map((project) => (*/}
      {/*        <option key={project.id} value={project.id}>*/}
      {/*          {project.name_text}*/}
      {/*        </option>*/}
      {/*      ))}*/}
      {/*    </select>*/}
      {/*  </div>*/}
      {/*)}*/}

      {selectedProjectId && (
        <>
          {/* Кнопка открытия модального окна */}
          <button onClick={() => setIsModalOpen(true)} className="btn-create">
            Добавить критерий
          </button>

          {/* Список критериев */}
          <div className="criteria-list">
            <h3>Критерии проекта</h3>
            {criteria.length === 0 ? (
              <p>Нет критериев. Создайте первый.</p>
            ) : (
              <ul>
                {criteria.map((criterion, index) => (
                  <li
                    key={criterion.id}
                    className="list-group-item"
                    style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}
                  >
                    <div style={{ flex: 1 }}>
                      <CriteriaItem criterion={criterion} onUpdate={handleUpdateOptions} onMove={() => {}} />
                    </div>
                    {/* Кнопки перемещения — справа от карточки */}
                    <div className="btn-group-vertical" style={{ marginLeft: '8px' }}>
                      <button
                        type="button"
                        className="btn btn-sm btn-secondary"
                        onClick={() => moveCriterion(index, 'up')}
                        disabled={index === 0}
                        aria-label="Переместить вверх"
                      >
                        ↑
                      </button>
                      <button
                        type="button"
                        className="btn btn-sm btn-secondary"
                        onClick={() => moveCriterion(index, 'down')}
                        disabled={index === criteria.length - 1}
                        aria-label="Переместить вниз"
                      >
                        ↓
                      </button>
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </>
      )}

      {/* Модальное окно */}
      {isModalOpen && (
        <CreateCriteriaModal
          projectId={selectedProjectId}
          onCreate={handleCreate}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </div>
  );
};

export default QualitySettingsPage;
